/**
 * Создает новую функцию, для которой если уже есть активный вызов, возвращает его промис
 * @template A
 * @template R
 * 
 * @param {(...args: A) => Promise<R>} fn 
 * @returns {(...args: A) => Promise<R>}
 */
export const debouncePromised = (fn) => {
    if (typeof fn !== 'function') throw new Error('arg of debouncePromised must be function');

    const heap = {};

    const debounced = (...args) => {
        const key = JSON.stringify(args);
        if (!(key in heap)) heap[key] = {};

        const that = heap[key];

        if (that.pending && that.promise) return that.promise; 

        const promised = async (...args) => {
            return await fn(...args);
        };

        that.promise = new Promise((res, rej) => {
            that.pending = true;
            promised(...args)
                .then(res)
                .catch(rej)
                .finally(() => {
                    that.pending = false;
                });
        })
    
        return that.promise;
    }

    return debounced;
};